/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'next-i18next'
import { SendOutlined } from '@ant-design/icons'
import { forgotPassword } from 'src/core/helpers'
import { showNotification } from 'src/core/helpers'
import React, { useEffect, useState } from 'react'
import styles from './ChangePasswordForm.module.scss'
import { Row, Divider, Form, Button, Input } from 'antd'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import ChangePasswordErrorModal from './ChangePasswordErrorModal/ChangePasswordErrorModal'
import { resetChangePasswordState, changePassword, changePasswordSelector } from 'src/features'
import { FormLabels, CustomPasswordInput, CustomConfirmPasswordInput, CustomCol, CustomText } from 'src/components'

const ChangePasswordForm = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [form] = Form.useForm()
  const { loading, success, errorMessage } = useAppSelector(changePasswordSelector)

  const onFinish = (values: { old_password: string, password: string, confirmation_password: string }) => {
    dispatch(changePassword({
      ...values,
      new_password: values?.password
    }))
  }

  useEffect(() => {
    return () => { dispatch(resetChangePasswordState()) }
  }, [dispatch])

  useEffect(() => { setIsModalVisible(errorMessage !== null) }, [errorMessage])

  useEffect(() => {
    if (success) {
      showNotification('success', t('settings.ChangePasswordSuccess'))
      dispatch(resetChangePasswordState())
      form.resetFields()
    }
  }, [success])

  return <>
    <Form
      name='credentialsForm'
      onFinish={onFinish}
      autoComplete='off'
      className='mt-3'
      form={form}
    >
      {/* Old Password */}
      <Row>
        <CustomCol>
          <FormLabels
            title={t('settings.OldPassword')}
            subtitle={t('general.RequiredField')}
          />
        </CustomCol>
        <CustomCol>
          <Form.Item
            name={'old_password'}
            rules={[{ required: true, message: t('general.RequiredValidation'), whitespace: true }]}
          >
            <Input.Password
              placeholder={t('admin.Brokerage.PasswordPlaceHolder')}
              size='large'
            />
          </Form.Item>
        </CustomCol>
      </Row>
      <Divider className={styles.divider} />
      {/* New Password*/}
      <Row>
        <CustomCol>
          <FormLabels
            title={t('settings.NewPassword')}
            subtitle={t('general.RequiredField')}
          />
        </CustomCol>
        <CustomCol>
          <CustomPasswordInput
            name={'password'}
            placeholder={t('admin.Brokerage.PasswordPlaceHolder')}
            type='password'
            required
          />
          <CustomText label={t('admin.Brokerage.PassValLabel')} type='secondary' />
        </CustomCol>
      </Row>
      {/* Confirm Password */}
      <Row>
        <CustomCol>
          <FormLabels
            title={t('admin.Brokerage.ComfirmPassowrd')}
            subtitle={t('general.RequiredField')}
          />
        </CustomCol>
        <CustomCol>
          <CustomConfirmPasswordInput
            name={'confirmation_password'}
            placeholder={t('admin.Brokerage.ComfirmPassowrdPlaceHolder')}
          />
        </CustomCol>
      </Row>
      <Divider />

      {/* Buttons */}
      <Row className='mt-5'>
        <CustomCol xs={14} lg={14}>
          <Button
            type='link'
            className={'radius-100'}
            onClick={() => forgotPassword()}
          >
            {t('settings.ForgotPassword')}
          </Button>
        </CustomCol>
        <CustomCol xs={10} lg={10}>
          <Button
            type='primary'
            htmlType='submit'
            shape='round'
            loading={loading}
            icon={<SendOutlined />}
            className='float-right radius-100'
            block
          >
            {loading ? t('settings.ChangingPassword') : t('general.Submit')}
          </Button>
        </CustomCol>
      </Row >
    </Form>

    <ChangePasswordErrorModal
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
    />
  </>
}

export default ChangePasswordForm
